/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { Component, Injector, Input } from '@angular/core';
import { type Command, DeleteAbstract } from '@dm/core';
import { type CIFSClient, type CIFSShare } from 'app/common/types/mo';

import { ShareTypeE } from '../../../share.enum';
import { CifsShareStrService } from '../../cifs-share-str.service';
import { ClientCifsShareService } from '../client-cifs-share.service';
import { prefixHandler } from '../client-clifs-share';

@Component({
    selector: 'app-remove-client-cifs-share',
    templateUrl: './remove-client-cifs-share.component.html',
    styleUrls: ['./remove-client-cifs-share.component.scss'],
})
export class RemoveClientCifsShareComponent extends DeleteAbstract<CIFSClient> {
    /**
     * 传入的当前要删除的client所属的share
     */
    @Input() cifsShare: CIFSShare;
    i18n = this.str.i18n;

    constructor(
        private str: CifsShareStrService,
        private service: ClientCifsShareService,
        injector: Injector,
    ) {
        super(injector);
    }

    initTable(): void {
        this.tableColumnDefs = [
            {
                field: 'NAME',
                header: this.i18n.label.userOrGroup,
                filterType: 'search',
                render: (value: string) => prefixHandler(value), // 如果是用户组，会多一个@符号
            },
            {
                field: 'DOMAINTYPE',
                header: this.i18n.label.type,
                columnFilter: true,
                render: (value, col, data: CIFSClient) => this.str.getUpperCaseUserOrGroupType(data),
            },
        ];
    }

    buildCmds(): Command[] {
        const cmds: Command[] = this.dataList.map((data) => {
            const typeStr = this.str.getUpperCaseUserOrGroupType(data);
            return {
                name: this.cifsShare.subType === ShareTypeE.Homedir ? this.i18n.rest.homedir.removeClients : this.i18n.rest.removeClients,
                nameParams: [typeStr, prefixHandler(data.NAME)],
                action: this.service.remove(data.ID, data.vstoreId),
            };
        });
        return cmds;
    }
}
